<svg
  width="17"
  height="16"
  viewBox="0 0 17 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M13.9998 13.3333L11.4175 10.751M11.4175 10.751C12.2922 9.87635 12.8332 8.66802 12.8332 7.33333C12.8332 4.66396 10.6692 2.5 7.99984 2.5C5.33046 2.5 3.1665 4.66396 3.1665 7.33333C3.1665 10.0027 5.33046 12.1667 7.99984 12.1667C9.33453 12.1667 10.5429 11.6257 11.4175 10.751Z"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="square"
  />
</svg>
